import { ThemeEvents } from '@theme/events';

/**
 * <pdp-unit-price> — toont de PER-STUK productprijs onder de titel.
 *
 * Bewust een eigen element (géén <product-price>, geen "price" in de class):
 * de configurator-app overschrijft de native theme-prijzen met het TOTAAL
 * (aantal × prijs). Dit element blijft dus de per-stuk prijs en beweegt enkel
 * mee met de variant (Type/Lengte), niet met het aantal.
 *
 * Update-patroon gelijk aan product-price.js: bij een variant-wissel rendert
 * het theme de sectie opnieuw en levert de nieuwe HTML via het event mee.
 */
class PdpUnitPrice extends HTMLElement {
  /** @type {Element | null} */
  #listenTarget = null;

  connectedCallback() {
    this.#listenTarget = this.closest('.shopify-section, dialog, quick-add-dialog');
    this.#listenTarget?.addEventListener(ThemeEvents.variantUpdate, this.#update);
  }

  disconnectedCallback() {
    this.#listenTarget?.removeEventListener(ThemeEvents.variantUpdate, this.#update);
    this.#listenTarget = null;
  }

  #update = (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;
    const fresh = html.querySelector('pdp-unit-price');
    if (fresh) this.replaceChildren(...fresh.cloneNode(true).childNodes);
  };
}

if (!customElements.get('pdp-unit-price')) {
  customElements.define('pdp-unit-price', PdpUnitPrice);
}
